// A dossier normally takes 30-90 seconds. If the server still says "generating" after this long, stop
// asking: the screen says it is taking longer than usual and the Close button works again.
export const POLL_LIMIT_MS = 5 * 60 * 1000;

export function pollTimedOut(startedAt, now = Date.now()) {
  return now - startedAt > POLL_LIMIT_MS;
}
